import { CallPROSolarmanLastActionResponse } from "ngx-modbus";

export const computeCRC32 = (
  buffer: ArrayBuffer,
  start = 0,
  length?: number
): number => {
  let crc = 0xFFFFFFFF;
  const end = start + (length ?? (buffer.byteLength - start));
  const data = new Uint8Array(buffer, start, end - start);
  for (let i = 0; i < data.length; i++) {
    crc ^= data[i];
    for (let j = 0; j < 8; j++) {
      crc = (crc & 1) ? (crc >>> 1) ^ 0xEDB88320 : crc >>> 1;
    }
  }
  return (crc ^ 0xFFFFFFFF) >>> 0;
};

export const isLoggerUpgrading$ = (_lastAction: CallPROSolarmanLastActionResponse | null | undefined) => {
  if (!_lastAction) {
    return false;
  }
  const create = _lastAction.createTime;
  const updateTime = _lastAction.updateTime;
  const orderTimeout = _lastAction.orderTimeout * 1000;
  const isInsideTimeout = updateTime - create < orderTimeout;
  const hasError = _lastAction.status === 500 || _lastAction.error;
  const hasSuccess = _lastAction.status === 666;
  const isTerminated = _lastAction.status === 400;
  return isInsideTimeout && !hasError && !hasSuccess && !isTerminated;
};
